import { ReviewCanvasContext } from 'modules/match-video/domain/interfaces';

/** Draws a picture inside the box keeping its proportions, centred — CSS `object-fit: contain`. */
export function drawContained(
  ctx: ReviewCanvasContext,
  image: HTMLImageElement,
  x: number,
  y: number,
  width: number,
  height: number,
): void {
  const iw = image.naturalWidth || image.width;
  const ih = image.naturalHeight || image.height;
  if (!iw || !ih) return;
  const scale = Math.min(width / iw, height / ih);
  const w = iw * scale;
  const h = ih * scale;
  ctx.drawImage(image, x + (width - w) / 2, y + (height - h) / 2, w, h);
}
